export enum MenuPortal {
    Corporate = 3,
    Account = 5
}
